<script lang="ts">
    import { DEFAULT_LAYOUT } from '$lib/components/constants';

    import GridColumnView from './GridColumn.View.svelte';

    import type { GridColumnContent } from '$lib/types/Components/GridColumn/GridColumnContent';
    import type { Component } from '$lib/types/Components/SharedTypes';
    import type { Field } from '$lib/types/Field';
    import type { Language } from '$lib/types/Language';
    import type { ResultMapping } from '$lib/types/ResultMapping';
    import type { Theme, TransitionEffect } from '$lib/types/Theme';
    import type { TrackingProperty } from '$lib/types/TrackingProperty';

    export let id = '';
    export let content: GridColumnContent;
    export let childComponents: Component[] = [];
    export let resultMapping: ResultMapping;
    export let theme: Theme;
    export let nextPage = '';
    export let currentPage = '';
    export let campaignId = '';
    export let campaignVersionId = '';
    export let companyId = '';
    export let cookiesEnabled = false;
    export let fields: Field[] = [];
    export let firstResultPage = '';
    export let trackingProperties: TrackingProperty[] = [];
    export let language: Language = 'en';
    export let transitionDelay = 0;
    export let transitionEffect: TransitionEffect = 'none';
    export let layout = DEFAULT_LAYOUT;
</script>

<GridColumnView
    box={content.box}
    verticalAlign={content.verticalAlign}
    framed={content.framed}
    hasShadow={content.hasShadow}
    {id}
    {childComponents}
    {resultMapping}
    {theme}
    {nextPage}
    {currentPage}
    {campaignId}
    {campaignVersionId}
    {companyId}
    {cookiesEnabled}
    {fields}
    {firstResultPage}
    {trackingProperties}
    {language}
    {transitionDelay}
    {transitionEffect}
    {layout}
/>
